<script setup lang="ts">
    import { filterLocalizedContent } from '../../utils/findLocalizedCenshareContent';
    import { sanitizeHtml } from '~/utils/sanitizeHtml';
    definePageMeta({ ssr: true });

    const { lang } = useLanguage();

    const { isLoggedIn } = useLoginState();
    const isLoggedInClient = useClientGate(isLoggedIn);

    const headers = useRequestHeaders(['cookie']);
    const { data } = await useFetch('/api/censhare/productitemgroup?limit=9999', { headers });
    const result = ref(data.value?.result || []);
    const visibleGroups = computed(() => {
        return result.value
            .filter((group) =>
                isLoggedInClient.value
                    ? filterLocalizedContent(group.mainContents, 'text.mandatorytext.hcp.', lang.value)?.length
                    : filterLocalizedContent(group.mainContents, 'text.mandatorytext.ec.', lang.value)?.length
            )
            .slice()
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    });

    const parseXml = (xmlString: string) => {
        return xmlString
            .replace(/<title>/g, '<h2>')
            .replace(/<\/title>/g, '</h2>')
            .replace(/<subtitle>/g, '<h3>')
            .replace(/<\/subtitle>/g, '</h3>')
            .replace(/<text>/g, '<div>')
            .replace(/<\/text>/g, '</div>')
            .replace(/<paragraph>/g, '<p>')
            .replace(/<\/paragraph>/g, '</p>')
            .replace(/<bold>/g, '<strong>')
            .replace(/<\/bold>/g, '</strong>');
    };
</script>

<template>
    <h1 v-if="isLoggedInClient">
        {{ $t('product.mandatoryTextHcp') }}
    </h1>
    <h1 v-else>
        {{ $t('product.mandatoryTextEc') }}
    </h1>

    <ClientOnly>
        <template
            v-for="group in visibleGroups"
            :key="group.id"
        >
            <div
                v-if="
                    isLoggedInClient &&
                    filterLocalizedContent(group.mainContents, 'text.mandatorytext.hcp.', lang)?.length
                "
                class="mandatory-text"
            >
                <div
                    v-for="text in filterLocalizedContent(group.mainContents, 'text.mandatorytext.hcp.', lang)"
                    :key="text.id"
                >
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-if="text.copytext"
                        v-html="sanitizeHtml(parseXml(text.copytext))"
                    ></div>
                    <!-- eslint-enable vue/no-v-html -->
                </div>
            </div>

            <div
                v-else-if="
                    !isLoggedInClient &&
                    filterLocalizedContent(group.mainContents, 'text.mandatorytext.ec.', lang)?.length
                "
                class="mandatory-text"
            >
                <div
                    v-for="text in filterLocalizedContent(group.mainContents, 'text.mandatorytext.ec.', lang)"
                    :key="text.id"
                >
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-if="text.copytext"
                        v-html="sanitizeHtml(parseXml(text.copytext))"
                    ></div>
                    <!-- eslint-enable vue/no-v-html -->
                </div>
            </div>
        </template>
    </ClientOnly>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/fachkreis/mandatory-text.scss';
</style>
